import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SecretCreatePage } from '@/features/access/secrets/secret-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/secrets/new')({ component: NewSecretRoute });

function NewSecretRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="secrets"
      crumbs={[{ label: t('access.secrets.title') }, { label: t('access.secrets.newTitle') }]}
    >
      <SecretCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
